import React from "react";
import styles from "./css/styles.module.css";

const MobileDisplay = () => {
  return <div className={styles.mobile_display}>This is mobile display</div>;
};

export default MobileDisplay;
